(()=>{
 function init(root=document){
  root.querySelectorAll('[data-pbhm-video]').forEach(video=>{
   if(video.dataset.ready)return;
   video.dataset.ready='true';
   const reduced=matchMedia('(prefers-reduced-motion:reduce)');
   let userPaused=false;
   const load=()=>{if(!video.getAttribute('src'))video.src=video.dataset.src;};
   const play=()=>{load();video.play().catch(()=>{});};
   video.addEventListener('keydown',e=>{
    if(e.code!=='Space'&&e.code!=='Enter')return;
    e.preventDefault();
    if(video.paused){userPaused=false;play();}else{userPaused=true;video.pause();}
   });
   if('IntersectionObserver' in window){
    new IntersectionObserver(entries=>entries.forEach(entry=>{
     if(entry.isIntersecting&&!reduced.matches&&!userPaused)play();
     else if(!entry.isIntersecting)video.pause();
    }),{threshold:0.05}).observe(video);
   }else if(!reduced.matches)play();
   reduced.addEventListener('change',()=>{if(reduced.matches)video.pause();});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
